import { ImgCell } from './ImgCell';
import { fromCamelCaseToWords } from '../../misc/functions';
import { NO_DATA } from '../../misc/misc.constants';
import type { Website } from '../../types';

interface FaviconCellProps {
  column: string;
  websiteData: Website;
  host: string;
}

export function FaviconCell({ column, websiteData, host }: FaviconCellProps) {
  const image = `https://${host}/${websiteData[column] as string}`;

  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      {websiteData[column] === NO_DATA ? (
        NO_DATA
      ) : (
        <ImgCell sources={[image]} />
      )}
    </td>
  );
}
